// src/admin/pages/support/tabs/SupportOverviewTab.jsx
import React from "react";
import { useParams } from "react-router-dom";
import SupportUserOverview from "../users/SupportUserOverview";

export default function SupportOverviewTab() {
  const { entityType, entityId } = useParams();

  if (entityType === "users") return <SupportUserOverview />;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5">
      <div className="text-[12px] font-semibold uppercase tracking-wider text-slate-500">Overview</div>
      <div className="mt-2 text-sm font-semibold text-slate-900">
        {String(entityType || "").toUpperCase()} overview coming soon.
      </div>
      <div className="mt-2 text-[13px] font-medium text-slate-500">
        Entity ID: <span className="font-semibold text-slate-900">{entityId}</span>
      </div>
    </div>
  );
}
